/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmBaseExecution {
    flavor: string;

    protected setDiscriminator(type: string) {
        this.flavor = type;
    }

    getFixupPrototypeFunction() { return AwsSsmBaseExecution.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmBaseExecution>): AwsSsmBaseExecution {
        let obj = Object.assign(new AwsSsmBaseExecution(), model);
        AwsSsmBaseExecution.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmBaseExecution>): AwsSsmBaseExecution {
        if (!model) return null;
        return AwsSsmBaseExecution.newInstance(<AwsSsmBaseExecution> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmBaseExecution) {
        if (!obj) return;

        models.AwsSsmBaseExecution.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmBaseExecution): boolean {
        switch (obj.flavor)
        {
            case "AwsSsmAutomationExecution":
                Object.setPrototypeOf(obj, models.AwsSsmAutomationExecution.prototype);
                break;
            case "AwsSsmCommandExecution":
                Object.setPrototypeOf(obj, models.AwsSsmCommandExecution.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof AwsSsmBaseExecution)[] {
        return [
            models.AwsSsmAutomationExecution,
            models.AwsSsmCommandExecution,
        ];
    }

    fixupFields() {
        if (this.targets) {
            for (let val of this.targets) {
                models.AwsSsmTarget.fixupPrototype(val);
            }
        }
    }

    inputs: { [key: string]: string; };

    /**
     * Details of the target.
     */
    targets: Array<models.AwsSsmTarget>;

    max_concurrency: string;

    /**
     * The maximum number of errors allowed without the command failing.
     */
    max_errors: string;

}
